var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{staticClass:"horario-tabs",attrs:{"background-color":"transparent","color":"primary","grow":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',[_vm._v("DIA")]),_c('v-tab',[_vm._v("ÚLTIMOS 10 DIAS")]),_c('v-tab',[_vm._v("PERÍODO")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }